/* eslint-disable no-nested-ternary */
import {
  Box, CardMedia, useTheme,
} from '@mui/material';
import { MetaItem } from '@optimus/models';
import { FALLBACK_IMAGE_URL } from '@optimus/utils/src/constant';
import { selectMemberSession } from '../../../store/slices/onboardingSlice';
import { useAppSelector } from '../../../store/hooks';
import ContentLinkedinPlayer from './ContentLinkedinVideo';
import ContentYoutubePlayer from './ContentYoutubeVideo';
import { ContentFeedSection } from '../../../common/models/content/Content';

interface ContentHeroBannerProps {
  logo?: string | null;
  banner?: {
    url: string | undefined;
    width: number | undefined;
    height: number | undefined;
  } | null,
  title?: string | null,
  heading?: string,
  shortDescription?: string,
  OnclickListener?: () => void,
  embedVideoUrl?: string | null,
  contentId: number,
  isContentDetailScreen?: boolean,
  backUrl?: string;
  contentCreatorName?: string | null
  contentMetaData?: MetaItem[]
  contentFeedSection?: ContentFeedSection
  contentFeedSectionPosition?: number
}

export default function ContentHeroBanner(props: ContentHeroBannerProps) {
  const theme = useTheme();
  const { memberId } = useAppSelector(selectMemberSession);

  const extractVideoId = (url: string) => {
    const lowerCaseUrl = url.toLowerCase();
    let regex: RegExp | undefined;
    if (lowerCaseUrl.includes('youtube')) {
      regex = /[?&]v=([a-zA-Z0-9_-]+)|\/shorts\/([a-zA-Z0-9_-]+)/;
    } else if (lowerCaseUrl.includes('tiktok')) {
      regex = /\/video\/(\d+)/;
    }
    if (!regex) return null;
    const match = url.match(regex);
    return match ? match[1] || match[2] : null;
  };

  return (
    <>
      {((props.title || '').toUpperCase() !== 'VIDEO' ||
        props?.embedVideoUrl?.toLowerCase()?.includes('tiktok')) && props.banner ? (
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              borderRadius: theme.spacing(2.25),
              overflow: 'hidden',
              cursor: 'pointer',
              mt: props.isContentDetailScreen ? `-${theme.spacing(2)}` : 0,
            }}
            onClick={props.OnclickListener}
          >
            {/* Aspect ratio spacer */}
            <Box sx={{ position: 'relative', paddingTop: '56.25%' }} />

            {/* Image */}
            <CardMedia
              component="img"
              image={props.banner.url ?? FALLBACK_IMAGE_URL}
              alt="banner"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </Box>
        ) : null}
      {
        (props.title || '').toUpperCase() === 'VIDEO' ?
          (props?.embedVideoUrl?.toLowerCase()?.includes('youtube') ?
            <Box>
              <ContentYoutubePlayer
                videoId={extractVideoId(props.embedVideoUrl) || ''}
                contentId={props.contentId}
                memberId={memberId}
                contentTitle={props.heading}
                contentCreatorName={props.contentCreatorName}
                title={props.title}
                heading={props.heading}
                contentMetaData={props.contentMetaData}
                contentFeedSection={props.contentFeedSection}
                contentFeedSectionPosition={props.contentFeedSectionPosition}
                thumbnailUrl={props?.banner?.url}
              />
            </Box> : (
              (
                props?.embedVideoUrl?.toLowerCase()?.includes('linkedin') ?
                  <Box sx={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                      }}
                    >
                      <ContentLinkedinPlayer
                        videoUrl={props.embedVideoUrl || ''}
                        contentId={props.contentId}
                        memberId={memberId}
                        contentTitle={props.heading}
                        contentCreatorName={props.contentCreatorName}
                      />
                    </Box>
                  </Box> :
                  null)
            )
          ) :
          null
      }
    </>
  );
}
